import React, { BaseSyntheticEvent } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import styled from 'styled-components';
import type { FCWithChildren } from '../../../types/FCWithChildren';

interface IStyledDivProps {
  disabled?: boolean;
}

interface ILinkThatCanBeDisabledProps extends LinkProps {
  disabled?: boolean;
}

const StyledDiv = styled.div<IStyledDivProps>`
  color: ${(props) => props.disabled && props.theme.colors.darkGray};
  cursor: ${(props) => props.disabled && 'not-allowed'};
`;

export const onClickPreventDefault = (event: BaseSyntheticEvent) => event.preventDefault();

const LinkThatCanBeDisabled: FCWithChildren<ILinkThatCanBeDisabledProps> = ({ disabled, to, onClick, children }) => {
  return (
    <Link to={to} onClick={disabled ? onClickPreventDefault : onClick}>
      <StyledDiv disabled={disabled}>{children}</StyledDiv>
    </Link>
  );
};

export default LinkThatCanBeDisabled;
